export const englishDictionary = require('./locale/en.json');
export const arabicDictionary = require('./locale/ar.json');



// WEBPACK FOOTER //
// ./src/app/helpers/translate.js